import React from 'react';
import OrderCard from '../OrderCard/OrderCard';
import { getStatusClass } from '../../../constants/orderStatuses';
import './KanbanColumn.css';

const KanbanColumn = ({ 
  status, 
  orders, 
  onCardClick, 
  onStatusChange,
  onDragOver,
  onDrop,
  onDragEnter,
  onDragLeave,
  isDragOver = false
}) => {
  const statusClass = getStatusClass(status).replace('status-', '');
  const lateOrdersCount = orders.filter(order => order.atrasado).length;

  return (
    <div className="kanban-column" data-status={status}>
      <div className={`column-header ${statusClass}`}>
        <h3>{status}</h3>
        <div className="column-counts">
          <span className="column-count">{orders.length}</span>
          {lateOrdersCount > 0 && (
            <span className="late-count" title={`${lateOrdersCount} pedido(s) atrasado(s)`}>
              ⚠️ {lateOrdersCount}
            </span>
          )}
        </div>
      </div>
      <div 
        className={`column-content ${isDragOver ? 'drag-over' : ''}`}
        data-status={status}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
      >
        {orders.map((order, index) => (
          <OrderCard
            key={`${order.idPed}-${index}`}
            order={order}
            onCardClick={onCardClick}
            onStatusChange={onStatusChange}
          />
        ))}
      </div>
    </div>
  );
};

export default KanbanColumn;
